import { Button, Card, Stack, styled, Typography } from "@schaeffler-commerce/design-system";
import type { CMSBannerDTO } from "~/features/cms/types/dto";
import { C_SECONDARY_CONTAINER } from "@schaeffler-commerce/design-system";
import { lineClamp } from "~/common/components/icon/FontUtils";
import { redirectToUrl } from "~/utils/url/urlUtils";

type WidgetProps = {
  data: CMSBannerDTO;
};
export default function Widget({ data }: WidgetProps) {
  const { headline, subheadline, linkLabel, linkUrl, imageUrl } = data;

  return (
    <WidgetContainer>
      <ImageContainer>
        <ImageCircle src={imageUrl} />
      </ImageContainer>
      <ContentContainer>
        <Stack sx={{
          gap: 1
        }}>
          <TruncatedTitle variant="titleLarge">{headline}</TruncatedTitle>
          <TruncatedSubTitle variant="bodyLarge">{subheadline}</TruncatedSubTitle>
        </Stack>
        <WidgetButton
          variant="text"
          onClick={() => {
            redirectToUrl(linkUrl);
          }}
        >
          {linkLabel}
        </WidgetButton>
      </ContentContainer>
    </WidgetContainer>
  );
}

const WidgetContainer = styled(Card)(({ theme }) => ({
  display: "flex",
  flex: "1 0 0",
  alignSelf: "stretch",
  backgroundColor: "white",
  [theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
  },
}));

const ImageContainer = styled("div")(({ theme }) => ({
  width: "200px",
  height: "240px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: C_SECONDARY_CONTAINER,
  flexShrink: 0,
  [theme.breakpoints.down("tablet")]: {
    width: "100%",
    height: "240px",
  },
}));

const ImageCircle = styled("img")(({ theme }) => ({
  backgroundColor: "white",
  width: "163px",
  height: "163px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  objectFit: "cover",
}));

const ContentContainer = styled(Stack)(({ theme }) => ({
  alignItems: "flex-start",
  padding: "24px",
  [theme.breakpoints.down("tablet")]: {
    padding: '"16px',
    gap: "8px",
  },
}));

const WidgetButton = styled(Button)(({ theme }) => ({
  marginTop: "auto",
  [theme.breakpoints.down("tablet")]: {
    marginTop: "8px",
  },
}));

const TruncatedTitle = styled(Typography)({
  ...lineClamp(2),
});
const TruncatedSubTitle = styled(Typography)({
  ...lineClamp(3),
});
